/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminSearchCustomersQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ServiceAdminSearchCustomersQuery = { __typename: 'Query', serviceAdminSearchCustomers: { __typename: 'ServiceAdminCustomerSearchPayload', totalCount: number, results: Array<{ __typename: 'ServiceAdminCustomerSearchResult', id: string, name: string, handle: string, organizationId: string, organizationName: string, displayCount: number, onboardedAdminEmail?: string | null, createdAt: any, accessState: Types.ServiceAdminGlobalSearchAccessState }> } };


export const ServiceAdminSearchCustomersDocument = gql`
    query ServiceAdminSearchCustomers($searchTerm: String!, $pageSize: Int, $pageNumber: Int) {
  serviceAdminSearchCustomers(
    searchTerm: $searchTerm
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    results {
      id
      name
      handle
      organizationId
      organizationName
      displayCount
      onboardedAdminEmail
      createdAt
      accessState
    }
  }
}
    `;

/**
 * __useServiceAdminSearchCustomersQuery__
 *
 * To run a query within a React component, call `useServiceAdminSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAdminSearchCustomersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useServiceAdminSearchCustomersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServiceAdminSearchCustomersQuery, ServiceAdminSearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceAdminSearchCustomersQuery, ServiceAdminSearchCustomersQueryVariables>(ServiceAdminSearchCustomersDocument, options);
      }
export function useServiceAdminSearchCustomersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceAdminSearchCustomersQuery, ServiceAdminSearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceAdminSearchCustomersQuery, ServiceAdminSearchCustomersQueryVariables>(ServiceAdminSearchCustomersDocument, options);
        }
export type ServiceAdminSearchCustomersQueryHookResult = ReturnType<typeof useServiceAdminSearchCustomersQuery>;
export type ServiceAdminSearchCustomersLazyQueryHookResult = ReturnType<typeof useServiceAdminSearchCustomersLazyQuery>;
export type ServiceAdminSearchCustomersQueryResult = ApolloReactCommon.QueryResult<ServiceAdminSearchCustomersQuery, ServiceAdminSearchCustomersQueryVariables>;